module.exports = __webpack_public_path__ + "static/media/thief.8c6e1c5c.svg";